import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, tap, switchMap } from 'rxjs/operators';
import { SeaculumAngularFormlyService } from '../../services/saeculum-angular-formly.service';
import { INFO_ICON } from '../../constant/common.constant';
import { FormBaseClass } from '../shared/base-class/form-base-class';
import { TypeaheadService } from '../../services/typeahead.service';

@Component({
  selector: 'saeculum-input-typeahead',
  templateUrl: './typeahead.component.html',
  styleUrls: ['./typeahead.component.css'],
  styles: [
    `::ng-deep.dropdown-menu.show {
        max-height: 400px !important;
        overflow-y: auto !important;
      }`
  ]
})
export class TypeaheadComponent extends FormBaseClass implements OnInit, OnChanges {
  @Input() fieldObj: any;
  @Input() options;
  @Input() values;
  @Input() form: FormGroup;
  @Input() type = '';
  @Output() valueChange = new EventEmitter<any>();
  infoIcon = INFO_ICON.icon;
  searching = false;
  searchFailed = false;

  constructor(
    public formService: SeaculumAngularFormlyService,
    public typeaheadService: TypeaheadService) {
    super();
  }

  formatMatches = (value: any) => value[this.fieldObj.templateOptions.bindLabel] || '';
  termSearch = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term => {
        if (this.fieldObj.templateOptions.typeaheadServerSide) {
          return this.typeaheadService.search(term, this.fieldObj.templateOptions.url).pipe(
            tap(() => this.searchFailed = false),
            catchError(() => {
              this.searchFailed = true;
              return of([]);
            }))
        } else {
          return of(term === '' ? []
            : (this.fieldObj.options || []).filter(v => v[this.fieldObj.templateOptions.bindLabel].toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
          );
        }
      }),
      tap(() => this.searching = false)
    )


  ngOnInit() {
    this.addControl();
  }

  addControl() {
    this.form.addControl(this.fieldObj.key, new FormControl(this.values ? this.values[this.fieldObj.key] : null));
    this.setValidations(this.form, this.fieldObj);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.values && changes.values.currentValue && this.form.get(this.fieldObj.key)) {
      this.form.get(this.fieldObj.key).setValue(changes.values.currentValue);
    }
  }

  notifyChange(event) {
    if (event && event.item) {
      this.valueChange.emit({ key: this.fieldObj.key, value: event.item });
    }
  }

}
